var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('div',{staticClass:"bg"},[_c('div',{attrs:{"id":"stars"}}),_c('div',{attrs:{"id":"stars2"}}),_c('div',{attrs:{"id":"stars3"}}),_c('Menu'),_c('AboutUs'),_c('transition',{attrs:{"name":"fade","mode":"out-in"}},[_c('router-view')],1)],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }